import { CounterpartyConnectStatusRUEnum } from '~/src/models/enums/counterparty-connect-status.enum';
import type { OrganizationInterface } from '~/src/repositories/organizations/types/organizations.types';

export const isContainsStatusConnectedOrganisations = (organisations: OrganizationInterface[]) => {
    return organisations.some(value =>
        CounterpartyConnectStatusRUEnum[value.connectingStatus] === CounterpartyConnectStatusRUEnum.CONNECTED);
};
